document.addEventListener("DOMContentLoaded", function () {
  const parentContainer = document.querySelector(".offer-introduction-wrapper");
  if (!parentContainer) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const childElements = entry.target.querySelectorAll(
            ".offer-introduction-element"
          );
          childElements.forEach((child, index) => {
            setTimeout(() => {
              child.classList.add("active");
            }, index * 500);
          });
        }
      });
    },
    {
      threshold: 0.2,
      rootMargin: "0px 10000px 0px 10000px",
    }
  );

  observer.observe(parentContainer);
});
